<template>
<div class="chapter">
<div class="inner_page">
<div id="fm6">
<a id="pagev">
<p class="dedication"><span>For</span></p>
<p class="dedication1"><span>George C. Wolfe who put it into motion,</span></p>
<p class="dedication1"><span>André Bishop and Bernard Gersten who made it happen,</span></p>
<p class="dedication1"><span>and Adele C-T who gave it the spirit</span></p>
</a></div><a id="pagev">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802195005_dedication.vue?02ca08c2